// assets
import secure from './secure.png'
import moneyBack from './money-back.png'
import dmca from './dmca.png'
import steam from './steam.png'
// types
import type { FooterTrustSealKind } from '../types/interfaces'

export interface FooterSealImage {
  src: string
  width: number
  height: number
}

export const TRUST_SEALS: Record<FooterTrustSealKind, FooterSealImage> = {
  'secure': { src: secure, width: 96, height: 96 },
  'money-back': { src: moneyBack, width: 96, height: 96 },
  'dmca': { src: dmca, width: 96, height: 96 },
  'steam': { src: steam, width: 92, height: 64 },
}
